import {Button, Checkbox, Col, Divider, Drawer, Form, message, Modal, Row, Select, Spin, Tag, Upload} from 'antd';
import {
    CheckCircleOutlined,
    CheckOutlined,
    CloseCircleOutlined,
    DownloadOutlined,
    PlusOutlined
} from "@ant-design/icons";
import './style.scss'
import {AdminWrapperDto} from "../../../dto/admin/AdminWrapperDto";
import {
    forwardRef,
    JSXElementConstructor,
    ReactElement,
    ReactNode,
    ReactPortal,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from "react";
import {CustomerDto} from "../../../dto/CustomerDto";
import Draggable, {DraggableData, DraggableEvent} from 'react-draggable';
import {
    ALLOWED_ALL_TYPES_TEXT,
    ALLOWED_DOCUMENT_TYPES,
    ALLOWED_IMAGE_TYPES,
    DOC_CODE_NIC_VERIFICATION_FRONT_DOC,
    DOC_CODE_NIC_VERIFICATION_REAR_DOC,
    DOC_CODE_PASSPORT_VERIFICATION_DOC,
    DOC_CODE_POLITICALLY_EXPOSED_PERSON_DOC,
    DOCUMENT_STATUS,
    DOCUMENT_TYPES,
    IDENTIFICATION_SOURCE,
} from "../../../util/Constants";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import documentService from "../../../service/documentService";
import {
    MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR,
    MSG_DOCUMENT_CHECKED_SUCCESS,
    MSG_DOCUMENT_NOT_FOUND_ERROR,
    MSG_DOCUMENT_REJECTED_SUCCESS,
    MSG_DOCUMENT_VERIFIED_SUCCESS,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_UPDATE_DOCUMENT_STATUS_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {DefaultDocumentDto} from "../../../dto/DefaultDocumentDto";
import PreviewModalComp from "../../common/preview/PreviewModalComp";
import {DocumentVerificationStatusDto} from "../../../dto/admin/DocumentVerificationStatusDto";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan, faCircleCheck, faClock, faStar} from "@fortawesome/free-solid-svg-icons";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import {ApprovalStatusDto} from "../../../dto/admin/ApprovalStatusDto";
import {CheckboxChangeEvent} from "antd/es/checkbox";
import CommonModalComp from "../../common/preview/CommonModalComp";
import {EyeOutlined} from "@ant-design/icons/lib";
import {toNumber} from "lodash";

interface RightSideDocumentProps {
    dataDto?: AdminWrapperDto,
    workBasketDto?: WorkbasketTableDto,
    onChildCompAction?: () => any,
    isCompareView: boolean
}

enum COMPARE_MODAL_SIDES {
    FRONT = 0,
    REAR = 1,
    DETAIL_PAGE = 2,
}

enum SELECT_OPTION {
    YES = "1",
    NO = "0"
}

interface WindowDimensions {
    width: number;
}

const RightSideDocument = forwardRef((props: RightSideDocumentProps, ref) => {
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;
    const [form] = Form.useForm();
    const [customerDto, setCustomerDto] = useState<CustomerDto>();
    const [nicFrontDocument, setNicFrontDocument] = useState<UploadedDocumentDetailDto>();
    const [nicRearDocument, setNicRearDocument] = useState<UploadedDocumentDetailDto>();
    const [passportDocument, setPassportDocument] = useState<UploadedDocumentDetailDto>();
    const [selectedDocumentId, setSelectedDocumentId] = useState<number>();
    const [drivingLicenseDocument, setDrivingLicenseDocument] = useState<UploadedDocumentDetailDto>();
    const [billingProofRelatedDocumentList, setBillingProofRelatedDocumentList] = useState<UploadedDocumentDetailDto[]>([]);
    const [bankRelatedDocumentList, setBankRelatedDocumentList] = useState<UploadedDocumentDetailDto[]>([]);
    const [otherRelatedDocumentList, setOtherRelatedDocumentList] = useState<UploadedDocumentDetailDto[]>([]);
    const [isSpinnerLoading, setSpinnerLoading] = useState<boolean>(false)
    const [documentName, setDocumentName] = useState<string>("")
    const [docURL, setDocURL] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCompareModalOpen, setCompareModalOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [isFrontDocCompBtnDisabled, setFrontDocCompBtnDisabled] = useState(true);
    const [isRearDocCompBtnDisabled, setRearDocCompBtnDisabled] = useState(true);
    const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggleRef = useRef<HTMLDivElement>(null);
    const [nicFrontUploadedList, setNicFrontUploadedList] = useState<DefaultDocumentDto[]>()
    const [nicRearUploadedList, setNicRearUploadedList] = useState<DefaultDocumentDto[]>()
    const [passportAdminUploadedList, setPassportAdminUploadedList] = useState<DefaultDocumentDto[]>()
    const [pepUploadedList, setPepUploadedList] = useState<DefaultDocumentDto[]>()
    const [pepStatus, setPepStatus] = useState<string|null>(null)
    const [compareModalDetails, setCompareModalDetails] = useState<{
        customerUploadedDocId?: number,
        identificationSourceType?: string,
        customerUploadedDocUrl?: string,
        dprUploadedDocUrl?: string,
        side?: string,
    }>({
        identificationSourceType: "",
        dprUploadedDocUrl: "",
        customerUploadedDocUrl: "",
        side: "",
        customerUploadedDocId: 0
    })
    const [adminUploadedNicFrontDocument, setAdminUploadedNicFrontDocument] = useState<UploadedDocumentDetailDto>();
    const [adminUploadedNicRearDocument, setAdminUploadedRearFrontDocument] = useState<UploadedDocumentDetailDto>();
    const [adminUploadedPassportDocument, setAdminUploadedPassportDocument] = useState<UploadedDocumentDetailDto>();
    const [adminUploadedPepDocument, setAdminUploadedPepDocument] = useState<UploadedDocumentDetailDto>();
    const [ceoApproval, setCeoApproval] = useState<boolean>(false);
    const [coApproval, setCoApproval] = useState<boolean>(false);


    useEffect(() => {
        setSpinnerLoading(false)
        setCustomerDto(props.dataDto?.customerMstDto)

    }, [props.dataDto]);
    useEffect(() => {
        setDocuments(props.dataDto?.documentDtoList)

    }, []);


    const openModal = (document: UploadedDocumentDetailDto | undefined, defaultDocument: DefaultDocumentDto | undefined) => {
        setIsModalOpen(false)
        setSpinnerLoading(true)
        let documentId: string = "";
        let documentName: string = "";
        if (undefined != defaultDocument) {
            documentId = defaultDocument.uid;
            documentName = defaultDocument.name
            setSelectedDocumentId(undefined)
        } else if (undefined != document) {
            documentId = document.uploadDocumentDetailId.toString();
            documentName = document.originalDocumentName
            setSelectedDocumentId(document.uploadDocumentDetailId)
        }
        viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setIsModalOpen(true)
                setDocumentName(documentName);
                setDocURL(res.data.results)
                setSpinnerLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setSpinnerLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinnerLoading(false)
        })
        return true;
    };


    useImperativeHandle(ref, () => ({

        passData(rejected: boolean): DocumentVerificationStatusDto {
            if(!rejected){
                form.validateFields()
            }
            return {
                nicFrontDocumentStatus: getDocStatus(nicFrontUploadedList),
                nicRearDocumentStatus: getDocStatus(nicRearUploadedList),
                pepDocumentStatus: getDocStatus(pepUploadedList),
                passportDocumentStatus: getDocStatus(passportAdminUploadedList),
                pepStatus: pepStatus,
                identificationSourceType: customerDto?.identificationSource?.sourceType,
                nicFrontCompared: checkDocumentComparedStatus(nicFrontDocument?.documentStatus),
                nicRearCompared: checkDocumentComparedStatus(nicRearDocument?.documentStatus),
                passportDetailCompared: checkDocumentComparedStatus(passportDocument?.documentStatus)
            } as DocumentVerificationStatusDto;
        },

        approvalData(): ApprovalStatusDto {
            return {
                ceoApproval: ceoApproval,
                coApproval: coApproval
            } as ApprovalStatusDto;
        }

    }));

    const onPepChange = (value: string) => {
        form.validateFields()
        setPepStatus(value)
    }

    const checkDocumentComparedStatus = (status: string | undefined) => {
        if (DOCUMENT_STATUS.VERIFIED == status || DOCUMENT_STATUS.REJECTED == status) {
            return true;
        } else {
            return false;
        }
    }

    const getDocStatus = (list: DefaultDocumentDto[] | undefined) => {
        return undefined != list && undefined != list[0];

    }
    const viewOriginalDocument = (documentId: string) => {
        return documentService.viewOriginalDocument(documentId)
    }
    const setDocuments = (documentList: [] | undefined) => {
        if (undefined != documentList) {
            documentList.map((document: any) => {
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;

                if (null != uploadDocumentDetailDto) {
                    let documentDto: DefaultDocumentDto = {
                        uid: uploadDocumentDetailDto.uploadDocumentDetailId.toString(),
                        url: uploadDocumentDetailDto.documentPath,
                        name: uploadDocumentDetailDto.originalDocumentName,
                        thumbUrl: uploadDocumentDetailDto.thumbB64
                    }
                    if (DOCUMENT_TYPES.NICF === uploadDocumentDetailDto.documentTypeId) {
                        setNicFrontDocument(uploadDocumentDetailDto)
                    } else if (DOCUMENT_TYPES.NICR === uploadDocumentDetailDto.documentTypeId) {
                        setNicRearDocument(uploadDocumentDetailDto)
                    } else if (DOCUMENT_TYPES.DLF === uploadDocumentDetailDto.documentTypeId) {
                        setDrivingLicenseDocument(uploadDocumentDetailDto)
                    } else if (DOCUMENT_TYPES.PASSPORT === uploadDocumentDetailDto.documentTypeId) {
                        setPassportDocument(uploadDocumentDetailDto)
                    } else if (DOCUMENT_TYPES.NICVF === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({nicFrontDoc: documentDto})
                        setNicFrontUploadedList([documentDto])
                        setAdminUploadedNicFrontDocument(uploadDocumentDetailDto)
                        setFrontDocCompBtnDisabled(false)
                    } else if (DOCUMENT_TYPES.NICVR === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({nicRearDoc: documentDto})
                        setNicRearUploadedList([documentDto])
                        setAdminUploadedRearFrontDocument(uploadDocumentDetailDto)
                        setRearDocCompBtnDisabled(false)
                    } else if (DOCUMENT_TYPES.PPV === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({passportDoc: documentDto})
                        setPassportAdminUploadedList([documentDto])
                        setAdminUploadedPassportDocument(uploadDocumentDetailDto)
                        setFrontDocCompBtnDisabled(false)
                    } else if (DOCUMENT_TYPES.PEP === uploadDocumentDetailDto.documentTypeId) {
                        form.setFieldsValue({pepDoc: documentDto})
                        setPepUploadedList([documentDto])
                        setAdminUploadedPepDocument(uploadDocumentDetailDto)
                    } else if ([DOCUMENT_TYPES.BP, DOCUMENT_TYPES.ASD].includes(uploadDocumentDetailDto.documentTypeId)) {
                        setBillingProofRelatedDocumentList((billingProofRelatedDocumentList: any) => [...billingProofRelatedDocumentList, uploadDocumentDetailDto])
                    } else if ([DOCUMENT_TYPES.PBCL, DOCUMENT_TYPES.SBCL].includes(uploadDocumentDetailDto.documentTypeId)) {
                        setBankRelatedDocumentList((bankRelatedDocument: any) => [...bankRelatedDocument, uploadDocumentDetailDto])
                    } else if ([DOCUMENT_TYPES.W9, DOCUMENT_TYPES.FATCA_FORM, DOCUMENT_TYPES.PROPIC, DOCUMENT_TYPES.SIGN].includes(uploadDocumentDetailDto.documentTypeId)) {
                        setOtherRelatedDocumentList((otherRelatedDocument: any) => [...otherRelatedDocument, uploadDocumentDetailDto])
                    }
                }
            })
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const showCompareModal = (side: number) => {
        setSpinnerLoading(true)
        let uploadedDPRDocumentId: string;
        let customerUploadedDocumentId: string;
        let sideString: string;

        if (COMPARE_MODAL_SIDES.FRONT === side) {
            uploadedDPRDocumentId = undefined === nicFrontUploadedList ? "0" : nicFrontUploadedList[0].uid;
            customerUploadedDocumentId = undefined === nicFrontDocument ? "0" : nicFrontDocument?.uploadDocumentDetailId.toString();
            sideString = "Front Page";
        } else if (COMPARE_MODAL_SIDES.REAR === side) {
            uploadedDPRDocumentId = undefined === nicRearUploadedList ? "0" : nicRearUploadedList[0].uid
            customerUploadedDocumentId = undefined === nicRearDocument ? "0" : nicRearDocument?.uploadDocumentDetailId.toString();
            sideString = "Rear Page";
        } else {
            uploadedDPRDocumentId = undefined === passportAdminUploadedList ? "0" : passportAdminUploadedList[0].uid
            customerUploadedDocumentId = undefined === passportDocument ? "0" : passportDocument?.uploadDocumentDetailId.toString();
            sideString = "Detail Page";
        }

        Promise.all([viewOriginalDocument(customerUploadedDocumentId), viewOriginalDocument(uploadedDPRDocumentId)]).then(res => {
            if (res.every((res) => res.status === 200)) {
                setCompareModalDetails({
                    identificationSourceType: customerDto?.identificationSource?.sourceType,
                    customerUploadedDocUrl: res[0].data.results,
                    dprUploadedDocUrl: res[1].data.results,
                    side: sideString,
                    customerUploadedDocId: Number.parseInt(customerUploadedDocumentId)
                })
                setCompareModalOpen(true);
                setSpinnerLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setCompareModalOpen(true);
                setSpinnerLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason);
            setCompareModalOpen(false);
            setSpinnerLoading(false)
        })
    };

    const handleCompareModalOk = (documentId: number | undefined) => {
        if (documentId) {
            verifyComparedDocuments(DOCUMENT_STATUS.VERIFIED, documentId)
        } else {
            message.error(MSG_DOCUMENT_NOT_FOUND_ERROR)
        }
    };

    const handleCompareModalCancel = (documentId: number | undefined) => {
        console.log()
        if (documentId) {
            verifyComparedDocuments(DOCUMENT_STATUS.REJECTED, documentId)
        } else {
            message.error(MSG_DOCUMENT_NOT_FOUND_ERROR)
        }
    };
    const onClose = () => {
        setCompareModalOpen(false)
    };
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };

    const configs = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: ".pdf, .jpeg, .jpg,  .png"
    };

    const beforeUploadNicFront = (file: any) => {
        setFrontDocCompBtnDisabled(false)
        return validateDocument(file, DOCUMENT_TYPES.NICVF);
    };

    const beforeUploadNicRear = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.NICVR);
    };
    const beforeUploadPassport = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.PPV);
    };

    const beforeUploadPepDocument = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.PEP);
    };

    const validateDocument = (file: any, type: DOCUMENT_TYPES) => {
        setSpinnerLoading(true)
        let allowedAllDocs = ALLOWED_DOCUMENT_TYPES.concat(ALLOWED_IMAGE_TYPES);
        let indexOf = allowedAllDocs.indexOf(file.type);
        if (indexOf < 0) {
            message.error(MSG_ALLOWED_ALL_DOCUMENT_TYPES_ERROR);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinnerLoading(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);
        formData.append("jobNo", JSON.stringify(customerDto?.id));
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId)
                setSpinnerLoading(false)
                enableCompare(type, false)
            } else {
                setSpinnerLoading(false)
                enableCompare(type, true)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinnerLoading(false)
            enableCompare(type, true)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const enableCompare = (type: DOCUMENT_TYPES, disable: boolean) => {
        switch (type) {
            case DOCUMENT_TYPES.NICVF: {
                setFrontDocCompBtnDisabled(disable);
                break;
            }
            case DOCUMENT_TYPES.NICVR: {
                setRearDocCompBtnDisabled(disable);
                break;
            }
            case DOCUMENT_TYPES.PPV: {
                setFrontDocCompBtnDisabled(disable);
                break;
            }
        }
    }
    const setUploadedDocumentList = (documents: any) => {
        documents.forEach((document: any) => {
            let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;
            createUploadedDocuments(uploadDocumentDetailDto, document.documentTypeId)
        })
        setSpinnerLoading(false)
    };
    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number) => {
        let defaultFileList: any;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.NICVF) {
            setNicFrontUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.NICVR) {
            setNicRearUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.PPV) {
            setPassportAdminUploadedList(defaultFileList)
        } else if (documentTypeId == DOCUMENT_TYPES.PEP) {
            setPepUploadedList(defaultFileList)
        }
    };

    const onRemove = (file: any, code: string, docId: DOCUMENT_TYPES) => {
        setSpinnerLoading(true)
        documentService.deleteDocumentById(getUidByCode(docId)).then(res => {
            if (res.data !== null) {
                setSpinnerLoading(false)
                enableDisableCompareBtnByDocId(true, docId);
                loadUploadedDocuments(customerDto?.id, [code])
                changeVerifiedDocumentStatus(code)
            } else {
                setSpinnerLoading(false)
                enableDisableCompareBtnByDocId(false, docId);
                message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            enableDisableCompareBtnByDocId(false, docId);
            setSpinnerLoading(false)
            ErrorHandler.handleError(reason);
        })

        return true;
    };

    const changeVerifiedDocumentStatus = (code: string) => {

        if (code !== DOC_CODE_POLITICALLY_EXPOSED_PERSON_DOC) {
            let customerUploadedDocumentId = 0;
            if (code === DOC_CODE_NIC_VERIFICATION_FRONT_DOC) {
                customerUploadedDocumentId = undefined === nicFrontDocument ? 0 : nicFrontDocument?.uploadDocumentDetailId
            } else if (code === DOC_CODE_NIC_VERIFICATION_REAR_DOC) {
                customerUploadedDocumentId = undefined === nicRearDocument ? 0 : nicRearDocument?.uploadDocumentDetailId
            } else if (code === DOC_CODE_PASSPORT_VERIFICATION_DOC) {
                customerUploadedDocumentId = undefined === passportDocument ? 0 : passportDocument?.uploadDocumentDetailId
            }

            documentService.updateApproveDocumentStatus({
                uploadDocumentDetailId: customerUploadedDocumentId,
                documentStatus: DOCUMENT_STATUS.PENDING
            }).then(res => {
                if (res.data !== null) {
                    updateDocumentStatus(res.data.results)
                } else {
                    message.error(MSG_FAILED_TO_UPDATE_DOCUMENT_STATUS_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }
    };

    const enableDisableCompareBtnByDocId = (disable: boolean, docId: DOCUMENT_TYPES) => {
        switch (docId) {
            case DOCUMENT_TYPES.NICVF: {
                setFrontDocCompBtnDisabled(disable)
                break;
            }
            case DOCUMENT_TYPES.NICVR: {
                setRearDocCompBtnDisabled(disable)
                break;
            }
            case DOCUMENT_TYPES.PPV: {
                setFrontDocCompBtnDisabled(disable)
                break;
            }
        }

    }

    const loadUploadedDocuments = (jobNo: number | undefined, identityDocumentTypeCodeList: string[]) => {
        setSpinnerLoading(true)
        if (jobNo) {
            documentService.getUploadDocumentListByType(jobNo, identityDocumentTypeCodeList).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList(res.data.results)
                    setSpinnerLoading(false)
                } else {
                    setSpinnerLoading(false)
                    message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
                }
            }, (reason) => {
                setSpinnerLoading(false)
                ErrorHandler.handleError(reason);
            })
        }

    };
    const getUidByCode = (docId: number): string => {

        switch (docId) {
            case DOCUMENT_TYPES.NICVF: {
                return undefined != nicFrontUploadedList ? nicFrontUploadedList[0].uid : "0";
            }
            case DOCUMENT_TYPES.NICVR: {
                return undefined != nicRearUploadedList ? nicRearUploadedList[0].uid : "0";
            }
            case DOCUMENT_TYPES.PPV: {
                return undefined != passportAdminUploadedList ? passportAdminUploadedList[0].uid : "0";
            }
            case DOCUMENT_TYPES.PEP: {
                return undefined != pepUploadedList ? pepUploadedList[0].uid : "0";
            }
            default: {
                return "0";
            }
        }
    };
    const verifyComparedDocuments = (documentStatus: DOCUMENT_STATUS, documentId: number) => {
        setCompareModalOpen(false)
        setSpinnerLoading(true)
        documentService.updateApproveDocumentStatus({
            uploadDocumentDetailId: documentId,
            documentStatus: documentStatus
        }).then(res => {
            if (res.data !== null) {
                showDocumentWiseMessages(documentStatus)
                updateDocumentStatus(res.data.results)
                setCompareModalOpen(false)
                setSpinnerLoading(false)
            } else {
                message.error(MSG_FAILED_TO_UPDATE_DOCUMENT_STATUS_ERROR).then();
                setCompareModalOpen(true)
                setSpinnerLoading(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setCompareModalOpen(true)
            setSpinnerLoading(false)
        })
    }
    const showDocumentWiseMessages = (documentStatus: DOCUMENT_STATUS) => {
        if (DOCUMENT_STATUS.VERIFIED == documentStatus) {
            message.success(MSG_DOCUMENT_VERIFIED_SUCCESS)
        } else {
            message.success(MSG_DOCUMENT_REJECTED_SUCCESS)
        }
    }


    const updateDocumentStatus = (uploadDocumentDetailDto: UploadedDocumentDetailDto) => {
        if (undefined != uploadDocumentDetailDto) {
            if (DOCUMENT_TYPES.NICF === uploadDocumentDetailDto.documentTypeId) {
                setNicFrontDocument(uploadDocumentDetailDto)
            } else if (DOCUMENT_TYPES.NICR === uploadDocumentDetailDto.documentTypeId) {
                setNicRearDocument(uploadDocumentDetailDto)
            } else if (DOCUMENT_TYPES.DLF === uploadDocumentDetailDto.documentTypeId) {
                setDrivingLicenseDocument(uploadDocumentDetailDto)
            } else if (DOCUMENT_TYPES.PASSPORT === uploadDocumentDetailDto.documentTypeId) {
                setPassportDocument(uploadDocumentDetailDto)
            } else if ([DOCUMENT_TYPES.BP, DOCUMENT_TYPES.ASD].includes(uploadDocumentDetailDto.documentTypeId)) {
                let updatedList = billingProofRelatedDocumentList.map((item) => {
                    if (item.documentTypeId === uploadDocumentDetailDto.documentTypeId) {
                        return uploadDocumentDetailDto;
                    }
                    return item;
                });
                setBillingProofRelatedDocumentList(updatedList);
            } else if ([DOCUMENT_TYPES.PBCL, DOCUMENT_TYPES.SBCL].includes(uploadDocumentDetailDto.documentTypeId)) {
                let updatedList = bankRelatedDocumentList.map((item) => {
                    if (item.documentTypeId === uploadDocumentDetailDto.documentTypeId) {
                        return uploadDocumentDetailDto;
                    }
                    return item;
                });
                setBankRelatedDocumentList(updatedList);
            } else if ([DOCUMENT_TYPES.W9, DOCUMENT_TYPES.FATCA_FORM, DOCUMENT_TYPES.PROPIC, DOCUMENT_TYPES.SIGN].includes(uploadDocumentDetailDto.documentTypeId)) {
                let updatedList = otherRelatedDocumentList.map((item) => {
                    if (item.documentTypeId === uploadDocumentDetailDto.documentTypeId) {
                        return uploadDocumentDetailDto;
                    }
                    return item;
                });
                setOtherRelatedDocumentList(updatedList);
            }
        }
    }
    const normFile = (e: { fileList: any; }) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    const getRibbon = (data: UploadedDocumentDetailDto | undefined) => {
        if (undefined != data && undefined != data.documentStatus) {
            switch (data.documentStatus) {

                case DOCUMENT_STATUS.VERIFIED: {
                    return (
                        <span className='verified-check-box verified_ribbon'>
                         Verified <FontAwesomeIcon icon={faStar}/>
                        </span>
                    )
                }
                case DOCUMENT_STATUS.CHECKED: {
                    return (
                        <span className='verified-check-box checked_ribbon'>
                         Checked  <FontAwesomeIcon icon={faCircleCheck}/>
                        </span>
                    )
                }
                case DOCUMENT_STATUS.REJECTED: {
                    return (
                        <span className='verified-check-box rejected_ribbon'>
                         Rejected  <FontAwesomeIcon icon={faBan}/>
                        </span>
                    )
                }
                case DOCUMENT_STATUS.PENDING: {
                    return (
                        <span className='verified-check-box pending_ribbon'>
                          Pending  <FontAwesomeIcon icon={faClock}/>
                        </span>
                    )
                }
            }
        } else {
            return (<></>)
        }
    }


    function getWindowDimensions(): WindowDimensions {
        const {innerWidth: width} = window;
        return {
            width
        };
    }

    const useWindowDimensions = (): WindowDimensions => {
        const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>(
            getWindowDimensions()
        );

        useEffect(() => {
            function handleResize() {
                setWindowDimensions(getWindowDimensions());
            }

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return windowDimensions;
    };
    const {width} = useWindowDimensions();

    const download = () => {
        let a = document.createElement('a');
        a.href = docURL;
        a.download = undefined != documentName ? documentName : "Document";
        a.click();
    }

    const onCheck = () => {
        setSpinnerLoading(true)
        closeModal()
        if (undefined != selectedDocumentId) {
            documentService.updateApproveDocumentStatus({
                uploadDocumentDetailId: selectedDocumentId,
                documentStatus: DOCUMENT_STATUS.CHECKED
            }).then(res => {
                if (res.data !== null) {
                    message.success(MSG_DOCUMENT_CHECKED_SUCCESS).then();
                    updateDocumentStatus(res.data.results)
                    setSpinnerLoading(false)
                } else {
                    message.error(MSG_FAILED_TO_UPDATE_DOCUMENT_STATUS_ERROR).then();
                    setSpinnerLoading(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setSpinnerLoading(false)
            })
        }
    }
    return (
        <Spin spinning={isSpinnerLoading} tip="Loading" size="large">
            <div>

                <div id='modal-root'>
                    <div className="App">
                        {/*{props.isCompareView ?*/}
                            <>
                                {isModalOpen &&
                                    // <CustomModal updateDocumentStatus={updateDocumentStatus} onClose={closeModal}
                                    //              title={documentName} docURL={docURL}
                                    //              documentId={selectedDocumentId}/>

                                    <Drawer title={documentName} className='doc-view-drawer' placement="right"
                                            onClose={closeModal} open={true} mask={false} maskClosable={false}
                                            width={(width / 2) - 50}
                                            footer={
                                                props.isCompareView ?
                                                <div className='drawer_position_right_download_button'>
                                                    <Button className='btn_download' primary icon={<DownloadOutlined/>}
                                                            onClick={download}>
                                                        Download
                                                    </Button>
                                                    {selectedDocumentId ?
                                                        <Button onClick={onCheck} type='primary' className='checkButton'
                                                                icon={<CheckOutlined/>}>
                                                            Check
                                                        </Button> : <></>}

                                                </div> : null
                                            }
                                    >
                                        <div id="pdf-container">
                                            <PreviewModalComp docURL={docURL} divHeight={'60vh'}/>
                                        </div>

                                    </Drawer>

                                }
                            </>
                            {/*:*/}
                            {/*<>*/}
                            {/*    {isModalOpen &&*/}
                            {/*        <CommonModalComp*/}
                            {/*            modalProp={{isModalOpen: isModalOpen, title: documentName, docURL: docURL}}/>}*/}
                            {/*</>*/}

                        {/*}*/}


                    </div>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        initialValues={{remember: true}}
                        form={form}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div>
                                    {IDENTIFICATION_SOURCE.NIC === customerDto?.identificationSource?.sourceType ?
                                        <div>
                                            <Divider orientationMargin="0" className='upload-document-divider'
                                                     orientation="left">{IDENTIFICATION_SOURCE.NIC}</Divider>

                                            <div className='subtitle-and-compare-btn'>
                                                <h5>Front</h5>
                                                {props.isCompareView ?
                                                    <Button type='link' disabled={isFrontDocCompBtnDisabled}
                                                            onClick={() => showCompareModal(COMPARE_MODAL_SIDES.FRONT)}>Compare</Button>
                                                    :
                                                    <></>}
                                            </div>

                                            <div className=''>
                                                <Row gutter={16}>

                                                    <Col
                                                        xxl={props.isCompareView ? 12 : 12}
                                                        xl={props.isCompareView ? 12 : 12} lg={12}
                                                    >
                                                        <div className='utility_bill img-nic'>
                                                            <div className='utulity_bill_icon_div'>
                                                                <div className="img_div">
                                                                    <img src={nicFrontDocument?.thumbB64} alt=""/>
                                                                </div>
                                                                <div className='name_div'>
                                                                    <h5>{nicFrontDocument?.documentTypeName}</h5>
                                                                    {/*<h6>Size: 5MB </h6>*/}
                                                                </div>
                                                            </div>
                                                            <Button className='doc-view-btn'
                                                                    onClick={() => openModal(nicFrontDocument, undefined)}><EyeOutlined/></Button>
                                                            {getRibbon(nicFrontDocument)}
                                                        </div>
                                                    </Col>
                                                    {props.isCompareView ?
                                                        <Col xxl={props.isCompareView ? 12 : 12}
                                                             xl={props.isCompareView ? 12 : 12} lg={12}
                                                             className='compare-upload-area'>
                                                            <Form.Item
                                                                name={"nicFrontDoc"}
                                                                label=""
                                                                getValueFromEvent={normFile}
                                                                initialValue={nicFrontUploadedList && nicFrontUploadedList?.length > 0 ? [nicFrontUploadedList] : undefined}
                                                                rules={[{
                                                                    required: true,
                                                                    message: 'Please upload the front image of the NIC from DRP'
                                                                }]}>
                                                                <Upload
                                                                    {...configs}
                                                                    className='upload_comp'
                                                                    fileList={nicFrontUploadedList && nicFrontUploadedList?.length > 0 ? nicFrontUploadedList : undefined}
                                                                    listType="picture"
                                                                    onPreview={(e: any) => openModal(undefined, nicFrontUploadedList ? nicFrontUploadedList[0] : undefined)}
                                                                    onRemove={(e: any) => onRemove(e, DOC_CODE_NIC_VERIFICATION_FRONT_DOC, DOCUMENT_TYPES.NICVF)}
                                                                    beforeUpload={beforeUploadNicFront}
                                                                >
                                                                    {(undefined != nicFrontUploadedList ? nicFrontUploadedList.length : [].length) < 1 &&
                                                                        <Button>
                                                                            <div className='upload-btn-div'>
                                                                                <div className="upload-icon-div">
                                                                                    <PlusOutlined
                                                                                        style={{
                                                                                            fontSize: 20,
                                                                                            color: '#757575'
                                                                                        }}/>
                                                                                </div>
                                                                                <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload the Front Image of the NIC From DRP {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                                </div>
                                                                            </div>
                                                                        </Button>
                                                                    }
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                        :
                                                        <Col
                                                            xxl={props.isCompareView ? 12 :12}
                                                            xl={props.isCompareView ? 12 : 12} lg={12}
                                                        >
                                                            <div className='utility_bill img-nic'>
                                                                <div className='utulity_bill_icon_div'>
                                                                    <div className="img_div">
                                                                        <img
                                                                            src={adminUploadedNicFrontDocument?.thumbB64}
                                                                            alt=""/>
                                                                    </div>
                                                                    <div className='name_div'>
                                                                        <h5>{adminUploadedNicFrontDocument?.documentTypeName}</h5>
                                                                        {/*<h6>Size: 5MB </h6>*/}
                                                                    </div>
                                                                </div>
                                                                <Button className='doc-view-btn'
                                                                        onClick={() => openModal(adminUploadedNicFrontDocument, undefined)}><EyeOutlined/></Button>
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>

                                            </div>


                                            <div className='subtitle-and-compare-btn' style={{marginTop: 6}}>
                                                <h5>Rear</h5>
                                                {props.isCompareView ?
                                                    <Button type='link' disabled={isRearDocCompBtnDisabled}
                                                            onClick={() => showCompareModal(COMPARE_MODAL_SIDES.REAR)}>Compare</Button>
                                                    :
                                                    <></>}
                                            </div>

                                            <div className=''>
                                                <Row gutter={16}>
                                                    <Col xxl={props.isCompareView ? 12 : 12}
                                                         xl={props.isCompareView ? 12 : 12} lg={12}>
                                                        <div className='utility_bill img-nic'>
                                                            <div className='utulity_bill_icon_div'>
                                                                <div className="img_div">
                                                                    <img src={nicRearDocument?.thumbB64} alt=""/>
                                                                </div>
                                                                <div className='name_div'>
                                                                    <h5>{nicRearDocument?.documentTypeName}</h5>
                                                                    {/*<h6>Size: 5MB </h6>*/}
                                                                </div>
                                                            </div>
                                                            <Button className='doc-view-btn'
                                                                    onClick={() => openModal(nicRearDocument, undefined)}><EyeOutlined/></Button>
                                                            {getRibbon(nicRearDocument)}
                                                        </div>
                                                    </Col>
                                                    {props.isCompareView ?
                                                        <Col xxl={props.isCompareView ? 12 : 12}
                                                             xl={props.isCompareView ? 12 : 12} lg={12}
                                                             className='compare-upload-area'>
                                                            <Form.Item
                                                                name={"nicRearDoc"}
                                                                label=""
                                                                getValueFromEvent={normFile}
                                                                initialValue={nicRearUploadedList && nicRearUploadedList?.length > 0 ? [nicRearUploadedList] : undefined}
                                                                rules={[{
                                                                    required: true,
                                                                    message: 'Please upload the rear image of the NIC from DRP'
                                                                }]}>
                                                                <Upload
                                                                    {...configs}
                                                                    className='upload_comp'
                                                                    fileList={nicRearUploadedList && nicRearUploadedList?.length > 0 ? nicRearUploadedList : undefined}
                                                                    listType="picture"
                                                                    onPreview={(e: any) => openModal(undefined, nicRearUploadedList ? nicRearUploadedList[0] : undefined)}
                                                                    onRemove={(e: any) => onRemove(e, DOC_CODE_NIC_VERIFICATION_REAR_DOC, DOCUMENT_TYPES.NICVR)}
                                                                    beforeUpload={beforeUploadNicRear}
                                                                >
                                                                    {(undefined != nicRearUploadedList ? nicRearUploadedList.length : [].length) < 1 &&
                                                                        <Button>
                                                                            <div className='upload-btn-div'>
                                                                                <div className="upload-icon-div">
                                                                                    <PlusOutlined
                                                                                        style={{
                                                                                            fontSize: 20,
                                                                                            color: '#757575'
                                                                                        }}/>
                                                                                </div>
                                                                                <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload the Rear Image of the NIC From DRP {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                                </div>
                                                                            </div>
                                                                        </Button>
                                                                    }
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                        :
                                                        <Col
                                                            xxl={props.isCompareView ? 12 : 12}
                                                            xl={props.isCompareView ? 12 : 12} lg={12}
                                                        >
                                                            <div className='utility_bill img-nic'>
                                                                <div className='utulity_bill_icon_div'>
                                                                    <div className="img_div">
                                                                        <img
                                                                            src={adminUploadedNicRearDocument?.thumbB64}
                                                                            alt=""/>
                                                                    </div>
                                                                    <div className='name_div'>
                                                                        <h5>{adminUploadedNicRearDocument?.documentTypeName}</h5>
                                                                        {/*<h6>Size: 5MB </h6>*/}
                                                                    </div>
                                                                </div>
                                                                <Button className='doc-view-btn'
                                                                        onClick={() => openModal(adminUploadedNicRearDocument, undefined)}><EyeOutlined/></Button>
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                            </div>
                                        </div>
                                        : IDENTIFICATION_SOURCE.PP === customerDto?.identificationSource?.sourceType ?
                                            <div>
                                                <Divider orientationMargin="0" className='upload-document-divider'
                                                         orientation="left">{IDENTIFICATION_SOURCE.PP}</Divider>

                                                <div className='subtitle-and-compare-btn'>
                                                    <h5>Detail Page</h5>
                                                    {props.isCompareView ?
                                                        <Button type='link' disabled={isFrontDocCompBtnDisabled}
                                                                onClick={() => showCompareModal(COMPARE_MODAL_SIDES.DETAIL_PAGE)}>Compare</Button>
                                                        :
                                                        <></>}

                                                </div>
                                                <div className=''>
                                                    <Row gutter={16}>
                                                        <Col xxl={props.isCompareView ? 12 : 12}
                                                             xl={props.isCompareView ? 12 : 12} lg={12}>
                                                            <div className='utility_bill img-nic'>
                                                                <div className='utulity_bill_icon_div'>
                                                                    <div className="img_div">
                                                                        <img src={passportDocument?.thumbB64} alt=""/>
                                                                    </div>
                                                                    <div className='name_div'>
                                                                        <h5>{passportDocument?.documentTypeName}</h5>
                                                                        {/*<h6>Size: 5MB </h6>*/}
                                                                    </div>
                                                                </div>
                                                                <Button className='doc-view-btn'
                                                                        onClick={() => openModal(passportDocument, undefined)}><EyeOutlined/></Button>
                                                                {getRibbon(passportDocument)}
                                                            </div>
                                                        </Col>
                                                        {props.isCompareView ?
                                                            <Col xxl={props.isCompareView ? 12 : 12}
                                                                 xl={props.isCompareView ? 12 : 12} lg={12}
                                                                 className='compare-upload-area'>
                                                                <Form.Item
                                                                    name={"passportDoc"}
                                                                    label=""
                                                                    getValueFromEvent={normFile}
                                                                    initialValue={passportAdminUploadedList && passportAdminUploadedList?.length > 0 ? [passportAdminUploadedList] : undefined}
                                                                    rules={[{
                                                                        required: true,
                                                                        message: 'Please upload an image of the passport detailed page'
                                                                    }]}>
                                                                    <Upload
                                                                        {...configs}
                                                                        className='upload_comp'
                                                                        fileList={passportAdminUploadedList && passportAdminUploadedList?.length > 0 ? passportAdminUploadedList : undefined}
                                                                        listType="picture"
                                                                        onPreview={(e: any) => openModal(undefined, passportAdminUploadedList ? passportAdminUploadedList[0] : undefined)}
                                                                        onRemove={(e: any) => onRemove(e, DOC_CODE_PASSPORT_VERIFICATION_DOC, DOCUMENT_TYPES.PPV)}
                                                                        beforeUpload={beforeUploadPassport}
                                                                    >
                                                                        {(undefined != passportAdminUploadedList ? passportAdminUploadedList.length : [].length) < 1 &&
                                                                            <Button>
                                                                                <div className='upload-btn-div'>
                                                                                    <div className="upload-icon-div">
                                                                                        <PlusOutlined
                                                                                            style={{
                                                                                                fontSize: 20,
                                                                                                color: '#757575'
                                                                                            }}/>
                                                                                    </div>
                                                                                    <div
                                                                                        className="upload-btn-text-div">
                                                                <span>
                                                                  Upload an Image of the Passport Detailed Page From DRP {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                                    </div>
                                                                                </div>
                                                                            </Button>
                                                                        }
                                                                    </Upload>
                                                                </Form.Item>
                                                            </Col>
                                                            :
                                                            <Col
                                                                xxl={props.isCompareView ? 12 : 12}
                                                                xl={props.isCompareView ? 12 : 12} lg={12}
                                                            >
                                                                <div className='utility_bill img-nic'>
                                                                    <div className='utulity_bill_icon_div'>
                                                                        <div className="img_div">
                                                                            <img
                                                                                src={adminUploadedPassportDocument?.thumbB64}
                                                                                alt=""/>
                                                                        </div>
                                                                        <div className='name_div'>
                                                                            <h5>{adminUploadedPassportDocument?.documentTypeName}</h5>
                                                                            {/*<h6>Size: 5MB </h6>*/}
                                                                        </div>
                                                                    </div>
                                                                    <Button className='doc-view-btn'
                                                                            onClick={() => openModal(adminUploadedPassportDocument, undefined)}><EyeOutlined/></Button>
                                                                </div>
                                                            </Col>}
                                                    </Row>
                                                </div>
                                            </div>
                                            : IDENTIFICATION_SOURCE.DL === customerDto?.identificationSource?.sourceType ?
                                                <div>
                                                    <Divider orientationMargin="0" className='upload-document-divider'
                                                             orientation="left">{IDENTIFICATION_SOURCE.DL}</Divider>
                                                    <h5>Detail Page</h5>
                                                    <Row gutter={16}>
                                                        <Col xxl={props.isCompareView ? 12 : 12}
                                                             xl={props.isCompareView ? 12 : 12} lg={12}>
                                                            <div className='utility_bill img-nic'>
                                                                <div className='utulity_bill_icon_div'>
                                                                    <div className="img_div">
                                                                        <img src={drivingLicenseDocument?.thumbB64}
                                                                             alt=""/>
                                                                    </div>

                                                                    <div className='name_div'>
                                                                        <h5>{drivingLicenseDocument?.documentTypeName}</h5>
                                                                        {/*<h6>Size: 5MB </h6>*/}
                                                                    </div>
                                                                </div>
                                                                <Button className='doc-view-btn'
                                                                        onClick={() => openModal(drivingLicenseDocument, undefined)}><EyeOutlined/></Button>
                                                                {getRibbon(drivingLicenseDocument)}
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                </div>
                                                : <></>}

                                    {billingProofRelatedDocumentList.length > 0 ?
                                        <Divider orientationMargin="0" className='upload-document-divider'
                                                 style={{marginTop: 10}} orientation="left">Residential
                                            Documents</Divider> : <></>}
                                    <Row gutter={[16, 16]}>
                                        {billingProofRelatedDocumentList.map((document: UploadedDocumentDetailDto) => {
                                            return <Col xxl={props.isCompareView ? 12 : 12}
                                                        xl={props.isCompareView ? 12 : 12} lg={12}>
                                                <div className='utility_bill'>
                                                    <div className='utulity_bill_icon_div'>
                                                        <div className="img_div">
                                                            <img src={document?.thumbB64} alt=""/>
                                                        </div>

                                                        <div className='name_div'>
                                                            <h5>{document?.documentTypeName}</h5>

                                                        </div>
                                                    </div>
                                                    <Button className='doc-view-btn'
                                                            onClick={() => openModal(document, undefined)}><EyeOutlined/></Button>
                                                    {getRibbon(document)}
                                                </div>
                                            </Col>
                                        })}
                                    </Row>
                                    <Divider orientationMargin="0" className='upload-document-divider'
                                             orientation="left">Bank Documents</Divider>
                                    <Row gutter={[16, 16]}>
                                        {bankRelatedDocumentList.map((document: UploadedDocumentDetailDto) => {
                                            return <Col xxl={props.isCompareView ? 12 : 12}
                                                        xl={props.isCompareView ? 12 : 12} lg={12}>
                                                <div className='utility_bill'>
                                                    <div className='utulity_bill_icon_div'>
                                                        <div className="img_div">
                                                            <img src={document?.thumbB64} alt=""/>
                                                        </div>

                                                        <div className='name_div'>
                                                            <h5>{document?.documentTypeName}</h5>

                                                        </div>
                                                    </div>
                                                    <Button className='doc-view-btn'
                                                            onClick={() => openModal(document, undefined)}><EyeOutlined/></Button>
                                                    {getRibbon(document)}
                                                </div>
                                            </Col>
                                        })}
                                    </Row>

                                    <Divider orientationMargin="0" className='upload-document-divider'
                                             orientation="left">Other Documents</Divider>
                                    <Row gutter={[16, 16]}>
                                        {otherRelatedDocumentList.map((document: UploadedDocumentDetailDto) => {
                                            return <Col xxl={props.isCompareView ? 12 : 12}
                                                        xl={props.isCompareView ? 12 : 12} lg={12}>
                                                <div className='utility_bill'>
                                                    <div className='utulity_bill_icon_div'>
                                                        <div className="img_div">
                                                            <img src={document?.thumbB64} alt=""/>
                                                        </div>

                                                        <div className='name_div'>
                                                            <h5>{document?.documentTypeName}</h5>
                                                        </div>
                                                    </div>
                                                    <Button className='doc-view-btn'
                                                            onClick={() => openModal(document, undefined)}><EyeOutlined/></Button>
                                                    {getRibbon(document)}
                                                </div>
                                            </Col>
                                        })}
                                    </Row>
                                    <Row gutter={[16, 16]} className='pep_comp'>
                                        <Col xxl={props.isCompareView ? 12 : 12} xl={props.isCompareView ? 12 : 12}
                                             lg={12} className='margin_bottom_upload_button'>
                                            {/*<Form layout="vertical">*/}
                                            {props.isCompareView ?
                                                <Form.Item label="Politically exposed person (PEP)"  name="pepStatus"
                                                           rules={[{
                                                               required: true,
                                                               message: 'Please select politically exposed status'
                                                           }]}>
                                                        <Select
                                                            // defaultValue={pepStatus}
                                                            placeholder={"Select politically exposed status"}
                                                            onChange={(e: string) => onPepChange(e)}
                                                            options={[{value: '1', label: 'Yes'},
                                                                {value: '0', label: 'No'},]}
                                                        />
                                                </Form.Item>
                                                :
                                                <Form.Item>
                                                    {SELECT_OPTION.YES == props.workBasketDto?.politicallyExposedStatus ?
                                                        <Tag icon={<CloseCircleOutlined/>} color="error"
                                                             style={{marginBottom: 12}}>
                                                            Politically exposed person
                                                        </Tag>
                                                        :
                                                        <Tag icon={<CheckCircleOutlined/>} color="success"
                                                             style={{marginBottom: 12}}>
                                                            Politically not exposed person
                                                        </Tag>
                                                    }
                                                </Form.Item>}
                                            {props.isCompareView ?
                                                <Form.Item
                                                    name={"pepDoc"}
                                                    label=""
                                                    getValueFromEvent={normFile}
                                                    initialValue={pepUploadedList && pepUploadedList?.length > 0 ? [pepUploadedList] : undefined}
                                                    rules={[{
                                                        required: true,
                                                        message: 'Please upload the politically exposed status document'
                                                    }]}>
                                                    <Upload
                                                        {...configs}
                                                        className='upload_comp'
                                                        fileList={pepUploadedList && pepUploadedList?.length > 0 ? pepUploadedList : undefined}
                                                        listType="picture"
                                                        onRemove={(e: any) => onRemove(e, DOC_CODE_POLITICALLY_EXPOSED_PERSON_DOC, DOCUMENT_TYPES.PEP)}
                                                        onPreview={(e: any) => openModal(undefined, pepUploadedList ? pepUploadedList[0] : undefined)}
                                                        beforeUpload={beforeUploadPepDocument}
                                                    >
                                                        {(undefined != pepUploadedList ? pepUploadedList.length : [].length) < 1 &&
                                                            <Button>
                                                                <div className='upload-btn-div'>
                                                                    <div className="upload-icon-div">
                                                                        <PlusOutlined
                                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                                    </div>
                                                                    <div className="upload-btn-text-div">
                                                                <span>
                                                                  Upload the Politically Exposed Status Document {ALLOWED_ALL_TYPES_TEXT}
                                                                </span>
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                        }
                                                    </Upload>
                                                </Form.Item>
                                                :
                                                <div className='utility_bill img-nic'>
                                                    <div className='utulity_bill_icon_div'>
                                                        <div className="img_div">
                                                            <img
                                                                src={adminUploadedPepDocument?.thumbB64}
                                                                alt=""/>
                                                        </div>
                                                        <div className='name_div'>
                                                            <h5>{adminUploadedPepDocument?.documentTypeName}</h5>
                                                            {/*<h6>Size: 5MB </h6>*/}
                                                        </div>
                                                    </div>
                                                    <Button className='doc-view-btn'
                                                            onClick={() => openModal(adminUploadedPepDocument, undefined)}><EyeOutlined/></Button>
                                                </div>
                                            }
                                            {/*</Form>*/}
                                        </Col>
                                    </Row>
                                    {props.isCompareView ?
                                        <></> :
                                        <Row gutter={[16, 16]} className='pep_comp'>
                                            <Col xxl={props.isCompareView ? 12 : 12} xl={props.isCompareView ? 12 : 12}
                                                 lg={12} className='margin_bottom_upload_button'>

                                                <div
                                                    className={'margin_top_20 checked-disabled-checkboxes admin-approval-checkboxes'}>
                                                    <Form.Item
                                                        name={"ceoApproval"}
                                                        label="">
                                                        <Checkbox defaultValue={ceoApproval}
                                                                  onChange={(e: CheckboxChangeEvent) => setCeoApproval(e.target.checked)}>
                                                            <h4 className='account-create-form-subheader'
                                                                style={{marginBottom: 0}}>CEO
                                                                Approval</h4></Checkbox>
                                                    </Form.Item>
                                                    <Form.Item
                                                        name={"coApproval"}
                                                        label="">
                                                        <Checkbox defaultValue={coApproval}
                                                                  onChange={(e: CheckboxChangeEvent) => setCoApproval(e.target.checked)}>
                                                            <h4
                                                                className='account-create-form-subheader'
                                                                style={{marginBottom: 0}}>Compliance
                                                                Officer Approval</h4></Checkbox>
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            </Col>
                        </Row>

                    </Form>
                </div>

                {/*Document Compare Modal*/}
                <Modal
                    width={750}
                    onCancel={onClose}
                    destroyOnClose={true}
                    className={'doc-compare-modal-height'}
                    title={
                        <div
                            style={{
                                width: '100%',
                                cursor: 'move',
                            }}
                            onMouseOver={() => {
                                if (disabled) {
                                    setDisabled(false);
                                }
                            }}
                            onMouseOut={() => {
                                setDisabled(true);
                            }}
                            // fix eslintjsx-a11y/mouse-events-have-key-events
                            // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/mouse-events-have-key-events.md
                            onFocus={() => {
                            }}
                            onBlur={() => {
                            }}
                            // end
                        >
                            {`${compareModalDetails.identificationSourceType} Compare`}
                        </div>
                    }
                    open={isCompareModalOpen}
                    footer={[
                        <Button key="back" type="primary" danger
                                onClick={() => handleCompareModalCancel(compareModalDetails.customerUploadedDocId)}>
                            Reject
                        </Button>,
                        <Button key="submit" type="primary"
                                onClick={() => handleCompareModalOk(compareModalDetails.customerUploadedDocId)}>
                            Verify
                        </Button>,
                    ]}
                    modalRender={(modal: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined) => (
                        <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            nodeRef={draggleRef}
                            onStart={(event, uiData) => onStart(event, uiData)}
                        >
                            <div ref={draggleRef}>{modal}</div>
                        </Draggable>
                    )}
                >
                    <Row gutter={[16, 16]}>
                        <Col sm={12} md={12} lg={12}>
                            <div className={'border_with_radias'}>
                                <h4>{`Customer Uploaded ${compareModalDetails.identificationSourceType} - ${compareModalDetails.side}`}</h4>
                                <PreviewModalComp docURL={compareModalDetails.customerUploadedDocUrl}
                                                  divHeight={'50vh'}/>
                            </div>
                        </Col>
                        <Col sm={12} md={12} lg={12} className={'pdf-col-height'}>
                            <div className={'border_with_radias'}>
                                <h4>{`${compareModalDetails.identificationSourceType} from DRP - ${compareModalDetails.side}`}</h4>
                                <PreviewModalComp docURL={compareModalDetails.dprUploadedDocUrl} divHeight={'50vh'}/>
                            </div>
                        </Col>
                    </Row>
                </Modal>

            </div>
        </Spin>
    );
});

export default RightSideDocument;
